import {createHelpers, getField, updateField} from 'vuex-map-fields'

const { getFieldBrandComponentItem, updateFieldBrandComponentItem } = createHelpers({
  getterType: 'getFieldBrandComponentItem',
  mutationType: 'updateFieldBrandComponentItem',
});

export default {
    state: {
        brandComponentItem: {},
    },
    actions: {
        async fetchBrandComponentItem(ctx, brandComponentID) {
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const res = await fetch("/api/component/" + brandComponentID, requestParams);
            if (!res.ok) {
                this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                return
            }
            const brandComponentItem = await res.json();
            ctx.commit('updateBrandComponentItem', brandComponentItem)
            console.log('brandComponentItem')
            console.log(brandComponentItem)
        },
        async saveBrandComponentItem(ctx, brandComponentID) {
            let csrfToken = this._vm.$readCookie('csrftoken')
            const requestParams = {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify({
                    'mpn': ctx.state.brandComponentItem.mpn,
                    'subcategory': ctx.state.brandComponentItem.subcategory,
                    'article': ctx.state.brandComponentItem.article,
                    'brand': ctx.state.brandComponentItem.brand,
                    'description': ctx.state.brandComponentItem.description,
                    'information': ctx.state.brandComponentItem.information,
                    'datasheet': ctx.state.brandComponentItem.datasheet,
                    'spec': ctx.state.brandComponentItem.spec,
                    'url': ctx.state.brandComponentItem.url,
                })
            };
            const res = await fetch("/api/component/" + brandComponentID + "/", requestParams);
            if (!res.ok) {
                this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                return
            }
        },
    },

    mutations: {
        updateFieldBrandComponentItem,
        updateBrandComponentItem(state, brandComponentItem) {
            state.brandComponentItem = brandComponentItem
        },
    },
    getters: {
        getFieldBrandComponentItem,
        getBrandComponentItem(state) {
            return state.brandComponentItem
        },
        getSelectBrandList(state, getters, rootState) {
            let brandList = []
            for (let brand of getters.getBrandList) {
                brandList.push({text: brand.name, value: brand.id})
            }
            return brandList
        },
        getComponentSpec(state) {
          let result = []
          if (state.brandComponentSpec != null) {
            for (let [key, value] of Object.entries(state.brandComponentSpec)) {
              if (value != null) {
                for (let [subKey, subValue] of Object.entries(value)) {
                  if (subValue != null && subValue != '')
                    result.push({'name': subKey, 'value': subValue['display_value'], 'group': key})
                }
              }
            }
          }
          return result
        },
    }
}